import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const mistakes = ["Enviar el signo de interrogación '?' solo te hace ver impaciente y necesitado.", "Darle 'Like' a sus fotos de Instagram para que se acuerde de ti es un grito de auxilio que mata el misterio.", "El 'Contacto Cero' pasivo no sirve si no sabes cómo rebotar cuando por fin deciden escribirte.", 'Las indirectas en los estados de WhatsApp son tan obvias que causan pena ajena en lugar de interés.'];
export const Mistakes = () => {
  return <section className="py-12 md:py-24 bg-brand-dark relative" data-id="element-98">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-100">
          <h3 className="font-display text-3xl md:text-6xl text-white uppercase mb-2 md:mb-4" data-id="element-101">
            Lo que has intentado{' '}
            <span className="text-brand-red line-through decoration-4" data-id="element-102">
              no funciona
            </span>
          </h3>
          <p className="text-base md:text-xl text-brand-gray mb-6 md:mb-12" data-id="element-103">
            Deja de cavar tu propia tumba digital.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-3 md:gap-6 text-left" data-id="element-104">
          {mistakes.map((mistake, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-darker p-4 md:p-6 border border-white/5 flex items-start space-x-3 md:space-x-4 hover:border-brand-red/30 transition-colors" data-id="element-105">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-brand-red flex-shrink-0 mt-0.5" data-id="element-106" />
              <p className="text-brand-light text-sm md:text-base leading-relaxed" data-id="element-107">
                {mistake}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};